import React from 'react';
import './Footer.css';

const Footer: React.FC = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <div className="footer-logo">
              <img src="/jkprintslogo.jpeg" alt="JK Prints" className="footer-logo-image" />
              <h3>JK Prints</h3>
            </div>
            <p>Your trusted partner for custom printing solutions. Quality products, exceptional service.</p>
          </div>
          
          <div className="footer-section">
            <h4>Contact Info</h4>
            <p>Phone: +91 96607 50779</p>
            <p>Email: jkprintsgroup@gmail.com</p>
            <p>Address: A1, sanwariya vihar, morija, jaipur, rajasthan</p>
          </div>
          
          <div className="footer-section">
            <h4>Quick Links</h4>
            <a href="/">Home</a>
            <a href="/products">Products</a>
            <a href="/custom-order">Custom Order</a>
          </div>
        </div>
        
        <div className="footer-bottom">
          <p>© 2024 JK Prints. All rights reserved.</p>
          <p className="developer-note">
            Want a similar website or app? Contact us at <a href="mailto:helpyamii@gmail.com" className="email-link">helpyamii@gmail.com</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
